import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { showError } from "../../constants/toasts";
import { useLazyGetRoleByIdQuery } from "../../services/role";
import { useEffect, useState } from "react";

const RoleDetail = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [isPrefilled, setIsPrefilled] = useState<boolean>(false);
  const [RoleById] = useLazyGetRoleByIdQuery();
  const { id } = useParams();

  const getDataByIdList = async () => {
    try {
      setIsLoading(true);
      if (!id) return;
      const numericId = Number(id);
      if (Number.isNaN(numericId)) return;
      const response = await RoleById({ id: numericId }).unwrap();
      if (
        (response as any).status === 200 ||
        (response as any).statusCode === 200
      ) {
        const userData = (response as any).data;
        setUser(userData);
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      showError(error?.message || error?.data?.message);
    }
  };

  useEffect(() => {
    getDataByIdList();
  }, [id]);

  return (
    <>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-subadmin")}>
            Manage Sub-Admin
          </span>{" "}
          -{" "}
          <span onClick={() => navigate("/manage-subadmin/roles")}>
            Manage Roles
          </span>{" "}
          - Role Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{user?.role_name || "N/A"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {user?.created_at
                ? moment(user.created_at).format("DD MMMM YYYY")
                : "N/A"}
            </p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">View</TableCell>
                <TableCell align="center">Add</TableCell>
                <TableCell align="center">Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              ) : Array.isArray(user?.permissions) &&
                user.permissions.length > 0 ? (
                user.permissions.map((perm: any) => (
                  <TableRow hover key={perm.id}>
                    <TableCell>{perm.module || "-"}</TableCell>
                    <TableCell align="center">
                      {perm.can_view ? (
                        <DoneIcon className="c_success" />
                      ) : (
                        <CloseIcon className="c_danger" />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {perm.can_add_edit ? (
                        <DoneIcon className="c_success" />
                      ) : (
                        <CloseIcon className="c_danger" />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {perm.can_add_edit ? (
                        <DoneIcon className="c_success" />
                      ) : (
                        <CloseIcon className="c_danger" />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {perm.can_be_delete ? (
                        <DoneIcon className="c_success" />
                      ) : (
                        <CloseIcon className="c_danger" />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No permissions found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default RoleDetail;
